import { useMemo } from 'react';
import { useSocket } from '@folklore/socket';

const useStorySocket = (story, onMessage) => {
    const storyId = story !== null ? story.id : null;
    const channels = useMemo(() => (storyId !== null ? [`stories.${storyId}`] : []), [storyId]);
    useSocket(channels, {
        onMessage,
    });
};

export default useStorySocket;
